var _a;
// FIXME: Type the envs
export var KeyAvailableServices;
(function (KeyAvailableServices) {
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_OBTER_SEGUNDA_VIA_CNH"] = process.env
        .ID_SERVICE_OBTER_SEGUNDA_VIA_CNH] = "ID_SERVICE_OBTER_SEGUNDA_VIA_CNH";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_RENOVAR_CNH"] = process.env.ID_SERVICE_RENOVAR_CNH] = "ID_SERVICE_RENOVAR_CNH";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_OBTER_CNH_DEFINITIVA"] = process.env.ID_SERVICE_OBTER_CNH_DEFINITIVA] = "ID_SERVICE_OBTER_CNH_DEFINITIVA";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_OBTER_PERMISSAO_INTERNACIONAL_DIRIGIR"] = process.env
        .ID_SERVICE_OBTER_PERMISSAO_INTERNACIONAL_DIRIGIR] = "ID_SERVICE_OBTER_PERMISSAO_INTERNACIONAL_DIRIGIR";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_RENOVAR_PERMISSAO_INTERNACIONAL_DIRIGIR"] = process.env
        .ID_SERVICE_RENOVAR_PERMISSAO_INTERNACIONAL_DIRIGIR] = "ID_SERVICE_RENOVAR_PERMISSAO_INTERNACIONAL_DIRIGIR";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_OBTER_SEGUNDA_VIA_PERMISSAO_INTERNACIONAL_DIRIGIR"] = process.env
        .ID_SERVICE_OBTER_SEGUNDA_VIA_PERMISSAO_INTERNACIONAL_DIRIGIR] = "ID_SERVICE_OBTER_SEGUNDA_VIA_PERMISSAO_INTERNACIONAL_DIRIGIR";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_AGENDAR_EXAMES_MEDICOS_PSICO_CNH"] = process.env
        .ID_SERVICE_AGENDAR_EXAMES_MEDICOS_PSICO_CNH] = "ID_SERVICE_AGENDAR_EXAMES_MEDICOS_PSICO_CNH";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_CONSULTAR_CNH"] = process.env.ID_SERVICE_CONSULTAR_CNH] = "ID_SERVICE_CONSULTAR_CNH";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_CONSULTAR_PROCESSO_CNH"] = process.env
        .ID_SERVICE_CONSULTAR_PROCESSO_CNH] = "ID_SERVICE_CONSULTAR_PROCESSO_CNH";
    KeyAvailableServices[KeyAvailableServices["ID_SERVICE_NEGATIVA_CNH"] = process.env.ID_SERVICE_NEGATIVA_CNH] = "ID_SERVICE_NEGATIVA_CNH";
})(KeyAvailableServices || (KeyAvailableServices = {}));
export var AVAILABLE_SERVICES = (_a = {},
    _a[KeyAvailableServices.ID_SERVICE_OBTER_SEGUNDA_VIA_CNH] = {
        isAvailable: true,
        whichRedirect: "gateway",
    },
    _a[KeyAvailableServices.ID_SERVICE_RENOVAR_CNH] = {
        isAvailable: true,
        whichRedirect: "middleware",
    },
    _a[KeyAvailableServices.ID_SERVICE_OBTER_CNH_DEFINITIVA] = {
        isAvailable: true,
        whichRedirect: "gateway",
    },
    _a[KeyAvailableServices.ID_SERVICE_OBTER_PERMISSAO_INTERNACIONAL_DIRIGIR] = {
        isAvailable: true,
        whichRedirect: "gateway",
    },
    _a[KeyAvailableServices.ID_SERVICE_RENOVAR_PERMISSAO_INTERNACIONAL_DIRIGIR] = {
        isAvailable: false,
        whichRedirect: "middleware",
    },
    _a[KeyAvailableServices.ID_SERVICE_OBTER_SEGUNDA_VIA_PERMISSAO_INTERNACIONAL_DIRIGIR] = {
        isAvailable: false,
        whichRedirect: "middleware",
    },
    _a[KeyAvailableServices.ID_SERVICE_AGENDAR_EXAMES_MEDICOS_PSICO_CNH] = {
        isAvailable: false,
        whichRedirect: "middleware",
    },
    _a[KeyAvailableServices.ID_SERVICE_CONSULTAR_CNH] = {
        isAvailable: false,
        whichRedirect: "middleware",
    },
    _a[KeyAvailableServices.ID_SERVICE_CONSULTAR_PROCESSO_CNH] = {
        isAvailable: true,
        whichRedirect: "gateway",
    },
    _a[KeyAvailableServices.ID_SERVICE_NEGATIVA_CNH] = {
        isAvailable: true,
        whichRedirect: "gateway",
    },
    _a);
// FIXME: Add evaluation service to PID
export var ID_SERVICES_AVALIACAO = [
    {
        id: Number(process.env.AVALIACAO_ID_OBTER_SEGUNDA_VIA_CNH),
        name: "Obter a Segunda Via da Minha Cnh",
        slug: "obter-a-segunda-via-da-minha-cnh",
    },
    {
        id: Number(process.env.AVALIACAO_ID_OBTER_CNH_DEFINITIVA),
        name: "Obter a Minha Cnh Definitiva",
        slug: "obter-a-minha-cnh-definitiva",
    },
    {
        id: Number(process.env.AVALIACAO_ID_RENOVAR_CNH),
        name: "Renovar a minha Cnh",
        slug: "renovar-a-minha-cnh",
    },
    {
        id: Number(process.env.AVALIACAO_ID_OBTER_NEGATIVA_CNH),
        name: "Emitir a certidão negativa da minha Cnh",
        slug: "emitir-certidao-negativa-da-minha-cnh",
    },
];
export var RequerimentoCNHEnum;
(function (RequerimentoCNHEnum) {
    RequerimentoCNHEnum[RequerimentoCNHEnum["ALTERACAO_DADOS"] = 8] = "ALTERACAO_DADOS";
    RequerimentoCNHEnum[RequerimentoCNHEnum["ALTORIZACAO_CONDUZIR_CICLOMOTOR"] = 1] = "ALTORIZACAO_CONDUZIR_CICLOMOTOR";
    RequerimentoCNHEnum["CNH_DEFINITIVA"] = "C";
    RequerimentoCNHEnum[RequerimentoCNHEnum["SEGUNDA_VIA_CNH"] = 2] = "SEGUNDA_VIA_CNH";
    RequerimentoCNHEnum["NOVO_PROCESSO_HABILITACAO"] = "E";
    RequerimentoCNHEnum[RequerimentoCNHEnum["RENOVACAO_CNH"] = 5] = "RENOVACAO_CNH";
    RequerimentoCNHEnum["NEGATIVA_CNH"] = "R001";
})(RequerimentoCNHEnum || (RequerimentoCNHEnum = {}));
export var RequerimentoPIDEnum;
(function (RequerimentoPIDEnum) {
    RequerimentoPIDEnum["OBTER_PID"] = "R002";
})(RequerimentoPIDEnum || (RequerimentoPIDEnum = {}));
export function recoverRequerimentoByServiceId(id) {
    switch (id) {
        case KeyAvailableServices.ID_SERVICE_OBTER_SEGUNDA_VIA_CNH:
            return RequerimentoCNHEnum.SEGUNDA_VIA_CNH;
        case KeyAvailableServices.ID_SERVICE_OBTER_CNH_DEFINITIVA:
            return RequerimentoCNHEnum.CNH_DEFINITIVA;
        case KeyAvailableServices.ID_SERVICE_RENOVAR_CNH:
            return RequerimentoCNHEnum.RENOVACAO_CNH;
        case KeyAvailableServices.ID_SERVICE_NEGATIVA_CNH:
            return RequerimentoCNHEnum.NEGATIVA_CNH;
        case KeyAvailableServices.ID_SERVICE_OBTER_PERMISSAO_INTERNACIONAL_DIRIGIR:
            return RequerimentoPIDEnum.OBTER_PID;
        default:
            return null;
        // throw new Error('Requerimento não encontrado');
    }
}
